/**
 * JobNavigation Component - Navigation between jobs
 */
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface JobNavigationProps {
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export const JobNavigation: React.FC<JobNavigationProps> = ({
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
}) => {
  return (
    <div className="flex items-center gap-2">
      <button
        onClick={onPrevious}
        disabled={!hasPrevious}
        className={`p-2 rounded-lg transition-colors ${
          hasPrevious
            ? 'bg-blue-600 hover:bg-blue-700 text-white'
            : 'bg-gray-200 dark:bg-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed'
        }`}
        title="Contagem anterior"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>
      <button
        onClick={onNext}
        disabled={!hasNext}
        className={`p-2 rounded-lg transition-colors ${
          hasNext
            ? 'bg-blue-600 hover:bg-blue-700 text-white'
            : 'bg-gray-200 dark:bg-gray-700 text-gray-400 dark:text-gray-500 cursor-not-allowed'
        }`}
        title="Próxima contagem"
      >
        <ChevronRight className="w-5 h-5" />
      </button>
    </div>
  );
};
